import React from "react";
import { CodeArticleInterface } from "../../../forms/OperationAjoutForm";

const InterfaceArticle = () => {
  return <div></div>;
};

export default InterfaceArticle;


interface PivotPaysBu {
  id: number
  pays_id: number
  bu_id: number
  date_suppression: any
  business_unit: Bu
  pays: Pays
}

export interface ArticleInterface {
  id: number;
  actif: boolean;
  libelle: string;
  idOperationIrm: any;
  idSocieteFacturation: any;
  activite_id: any;
  type_id: number;

  code_article_id: number;
  // association_parametrage_id: number;
  pivot_pays_bus_id: number;
  devise_id: number;
  date_suppression: any;
  code_article: CodeArticleInterface;
  // association_parametrage: AssociationParametrage;
  pivot_pays_bu: PivotPaysBu;
  activite: any;
  type: Type;
  devise: Devise;

  tarification_count: number;
  saisie_manager_count: number;
  cout_count: number;

  // operation_has_code_gesco: OperationHasCodeGesco;
  // operations_has_code_gesco_id: number;
  piv_oper_soc_code: PivOperSocCode;
}

export interface PivOperSocCode {
  id: number;
  operation_id: number;
  piv_socifact_code_id: number;
  operation: OperationInterface;
  piv_societe_fact_code: PivSocieteFactCode;
}

interface PivSocieteFactCode {
  id: number;
  code_gesco_id: number;
  societe_facturation_id: number;
  societe_facturation: SocieteFacturation;
  code_gesco: CodeGesco;
}



interface Bu {
  id: number;
  libelle: string;
  date_suppression: any;
}

interface Client {
  id: number;
  libelle: string;
  date_suppression?: any;
}

interface Pays {
  id: number;
  libelle: string;
  date_suppression: any;
}

interface Type {
  id: number;
  libelle: string;
}

interface Devise {
  id: number;
  monnaie: string;
  symbole: string;
  code_iso: string;
}


interface SocieteFacturation {
  id: number;
  libelle: string;
  activite?: any;
  forme_juridique?: any;
  capital?: any;
  adresse?: string;
  code_postal?: any;
  ville?: any;
  registre_commerce?: any;
  identifiant_fiscal?: any;
  pays_id?: number;
  code?: string;
  date_suppression?: any;
}

interface CodeGesco {
  id: number;
  libelle: string;
  code_gesco_sage_id?: any;
  date_suppression?: any;
}

export interface OperationInterface {
  id: number;
  libelle: string;
  clients_id: number;
  date_suppression?: any;
  client: Client;
}

export const tableColumnTittlesArticle = [
  {
    id: 5,
    tittle: "Societe Facturation",
    property: "societe_facturations.libelle",
    toSort: true
  },
  {
    id: 6,
    tittle: "Code gesco",
    property: "code_gescos.libelleCodeGesco",
    toSort: true
  },
  {
    id: 4,
    tittle: "Operation",
    property: "operationLibelle",
    toSort: true
  }
];

export interface OperationHasCodeGescoInterface {
  id: number;
  code_gesco_id: number;
  societe_facturation_id: number;
  operation_id: number;
  societe_facturation: SocieteFacturation;
  code_gesco: CodeGesco;
}

export interface DeviseInterface {
  id: number;
  monnaie: string;
  symbole: string;
  code_iso: string;
}


export interface ClientWithChildInterface {
  id: number
  libelle: string
  created_at: string
  updated_at: any
  date_suppression: any
  operations: OperationI[]
}

export interface OperationI {
  id: number
  libelle: string
  clients_id: number
  date_suppression?: string
  pivot_oper_socifact_code_gesco: PivotOperSocifactCodeGesco[]
  users: User[]
}

interface User {
  id: number
  name: string
  prenom: string
  pays: string
  profil_user_id: number
  date_suppression: any
}

interface PivotOperSocifactCodeGesco {
  id: number
  operation_id: number
  piv_socifact_code_id: number
  periode_facturations_id: any
  piv_socifact_code_gescos: PivSocifactCodeGescos
}

interface PivSocifactCodeGescos {
  id: number
  code_gesco_id: number
  societe_facturation_id: number
  societe_facturation: SocieteFacturation
  code_gesco: CodeGesco
}


